export class CplA48Labels {

    constructor({
        AUNLabel,
        ActivityType,
        CollegeCreditType,
        CECPerformanceStandard,
        CourseType
    }: {
        AUNLabel?: string,
        ActivityType?: string,
        CollegeCreditType?: string,
        CECPerformanceStandard?: string,
        CourseType?: string
    }) {
        this.AUNLabel = AUNLabel;
        this.ActivityType = ActivityType;
        this.CollegeCreditType = CollegeCreditType;
        this.CECPerformanceStandard = CECPerformanceStandard;
        this.CourseType = CourseType;
    }

    AUNLabel: string;
    ActivityType: string;
    CollegeCreditType: string;
    CECPerformanceStandard: string;
    CourseType: string;
}